import { render, staticRenderFns } from "./EditTucowsPromo.vue?vue&type=template&id=83f3a8d2"
import script from "./EditTucowsPromo.vue?vue&type=script&lang=js"
export * from "./EditTucowsPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports